import { isExperimentEnabled, getExperimentCohort } from '@atlassian/generative-ai-modal/utils/experiments';
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
export function _getFetchCustomHeaders() {
  const currentHost = window.location.origin;
  switch (true) {
    case currentHost === 'https://statlas.prod.atl-paas.net':
      // Update this to add custom headers when run in atlaskit branch deploys
      // ie.
      // {
      //   'X-CloudID': 'Magic string'
      // }
      return {};
    default:
      return {};
  }
}
export function deriveGenerativeAIApiUrl() {
  const currentHost = typeof window.location !== 'undefined' ? window.location.origin : '';
  switch (true) {
    // Not currently supported
    //
    // However search platform have wired up their example
    // so that localhost and statlaskit can speak to
    // pug.jira-dev.com.  Assumption is we will do the same.
    case currentHost.startsWith('http://localhost'):
    case currentHost === 'https://atlaskit-website-staging.stg-east.frontend.public.atl-paas.net':
    case currentHost === 'https://statlas.prod.atl-paas.net':
    case currentHost === 'https://atlaskit.atlassian.com':
      return 'https://pug.jira-dev.com/gateway/api/editor-ai/v1/generative/ai';
    default:
      return `${typeof window.location !== 'undefined' ? window.location.origin : ''}/gateway/api/editor-ai/v1/generative/ai`;
  }
}
export function convoAIDeriveGenerativeAIApiBaseUrl() {
  const currentHost = typeof window.location !== 'undefined' ? window.location.origin : '';

  // if currentHost starts with `http://localhost` then we should use https://pug.jira-dev.com/
  switch (true) {
    case currentHost.startsWith('http://localhost'):
    case currentHost === 'https://atlaskit-website-staging.stg-east.frontend.public.atl-paas.net':
    case currentHost === 'https://statlas.prod.atl-paas.net':
    case currentHost === 'https://atlaskit.atlassian.com':
      return 'https://pug.jira-dev.com';
    default:
      return `${typeof window.location !== 'undefined' ? window.location.origin : ''}`;
  }
}
export const convoAIStatelessApiURL = `${convoAIDeriveGenerativeAIApiBaseUrl()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
export function isDefined(value) {
  return value !== undefined;
}
export function getBackendModelExperiment() {
  const isGPT4Enabled = isExperimentEnabled('editor_ai_-_gpt4_experiment');
  const isEinsteinCohort = getExperimentCohort('editor_ai_-_gpt4_experiment') === 'einstein';
  return isGPT4Enabled && isEinsteinCohort ? 'einstein' : 'xp-gen-ai';
}